import Swiper, { Autoplay } from 'swiper'
import {mdBreakpoint} from "../utils/breakpoints"
import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin)

Swiper.use([Autoplay])

function initCardCarousels() {

  const cardCarouselBlocks = Array.from(document.querySelectorAll('.js-card-carousel-block'))

  cardCarouselBlocks.forEach(cardCarouselBlock => {

    const cardSwiperRow = cardCarouselBlock.querySelector('.js-card-carousel-swiper-row')
    const cardCarousel = cardCarouselBlock.querySelector('.js-card-carousel')
    const criteriaList = cardCarouselBlock.querySelector('.js-criteria-list')
    const showCriteriaListBtn = cardCarouselBlock.querySelector('.js-show-criteria-list-btn')
    const hideCriteriaListBtn = cardCarouselBlock.querySelector('.js-hide-criteria-list-btn')
    const carouselCards = Array.from(cardCarousel.querySelectorAll('.js-animate-carousel-card'))

    carouselCards.forEach((carouselCard, i) => {
      const carouselCardPosition = [i]
      if (carouselCardPosition % 2 === 0) {
        carouselCard.dataset.cardIsOdd = 'true'
      } else {
        carouselCard.dataset.cardIsOdd = 'false'
      }
    })

    const oddCarouselCards = gsap.utils.toArray('[data-card-is-odd=true]')
    const evenCarouselCards = gsap.utils.toArray('[data-card-is-odd=false]')

    let cardsAreBobbing = false
    let oddCardsBobbing
    let evenCardsBobbing

    if (mdBreakpoint.matches) {

      cardsAreBobbing = true

      oddCardsBobbing = gsap.fromTo(
        oddCarouselCards,
        {
          y: -17
        },
        {
          y: 17,
          duration: 2,
          ease: 'power1.inOut',
          yoyo: true,
          repeat: -1
        }
      )

      evenCardsBobbing = gsap.fromTo(
        evenCarouselCards,
        {
          y: 17
        },
        {
          y: -17,
          duration: 2,
          ease: 'power1.inOut',
          yoyo: true,
          repeat: -1
        }
      )
    }

    const stopCardsBobbing = () => {
      if (cardsAreBobbing === true) {
        oddCardsBobbing.kill()
        evenCardsBobbing.kill()
        gsap.to(
          carouselCards, {
            y: 0,
            duration: 1,
            ease: 'power1.out',
          }
        )
      }
    }

    const swiper = new Swiper(cardCarousel, {
      autoplay: {
        delay: 0
      },
      speed: 6000,
      grabCursor: true,
      slidesPerView: 'auto',
      freeMode: true,
      centerInsufficientSlides: true,
      on: {
        sliderMove: stopCardsBobbing
      }
    })

    let criteriaListVisible

    const resetCriteriaList = () => {

      if (!mdBreakpoint.matches && criteriaListVisible !== true) {
        cardCarouselBlock.style.minHeight = cardCarouselBlock.offsetHeight + 'px'
        gsap.set(showCriteriaListBtn, {
          display: 'block',
          autoAlpha: 1,
        })
      } else if (mdBreakpoint.matches) {
        cardCarouselBlock.style.minHeight = 'initial'
        if (criteriaListVisible === true) {
          gsap.set([
            hideCriteriaListBtn, showCriteriaListBtn], {
              display: 'none',
              autoAlpha: 0
          })
          gsap.set(criteriaList, {
            clipPath: 'inset(0% 0% 100% 0%)',
            autoAlpha: 0,
            height: 0,
          })
          gsap.set(cardSwiperRow, {
            autoAlpha: 1,
            height: 'auto',
            clipPath: 'inset(0% 0% 0% 0%)',
          })

          criteriaListVisible === false
        }
      }

    }

    const showCriteriaList = () => {

      criteriaListVisible = true

      gsap.timeline()
        .to(showCriteriaListBtn, {
          autoAlpha: 0,
          visibility: 'hidden',
          display: 'none',
          duration: 0.2,
          ease: 'power1',
        })
        .to(cardSwiperRow, {
          clipPath: 'inset(0% 0% 100% 0%)',
          autoAlpha: 0,
          height: 0,
          duration: 0.4,
          ease: 'power1.in',
        })
        .to(criteriaList, {
          autoAlpha: 1,
          height: 'auto',
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: 0.4,
          ease: 'power1.out',
        }, '+=0.2')
        .to(hideCriteriaListBtn, {
          display: 'block',
          autoAlpha: 1,
          duration: .2,
          ease: 'power1',
        })
    }

    const hideCriteriaList = () => {

      criteriaListVisible = false

      gsap.timeline()
        .to(hideCriteriaListBtn, {
          autoAlpha: 0,
          display: 'none',
          duration: 0.2,
          ease: 'power1',
        })
        .to(criteriaList, {
          clipPath: 'inset(0% 0% 100% 0%)',
          autoAlpha: 0,
          height: 0,
          duration: 0.4,
          ease: 'power1.in',
        })
        .to(cardSwiperRow, {
          autoAlpha: 1,
          height: 'auto',
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: 0.4,
          delay: 0.4,
          ease: 'power1.out',
        })
        .to(showCriteriaListBtn, {
          display: 'block',
          autoAlpha: 1,
          duration: 0.2,
          ease: 'power1',
        })
    }

    showCriteriaListBtn.addEventListener('click', showCriteriaList)
    hideCriteriaListBtn.addEventListener('click', hideCriteriaList)

    const invokeAfterResize = () => {
      let rtime
      let timeout = false
      const timeoutDuration = 200

      window.addEventListener('resize', () => {
        rtime = new Date()
        if (timeout === false) {
          timeout = true
          setTimeout(resizeEnd, timeoutDuration)
        }
      })

      const resizeEnd = () => {
        if (new Date() - rtime < timeoutDuration) {
          setTimeout(resizeEnd, timeoutDuration)
        } else {
          timeout = false

          resetCriteriaList()

          if (!mdBreakpoint.matches) {
            stopCardsBobbing()
          }

        }
      }
    }
    invokeAfterResize()
    resetCriteriaList()

  })
}
initCardCarousels()
